module.exports = __webpack_public_path__ + "static/media/cc-paypal.607f2030.svg";